/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")




export interface API20949Req {
  
  /** 排序资源 ,String */
  resourceIdList?: any[];
};



export interface API20949Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /**   */
  exceptionMsg?: string;
  
};


// 20949 增加常用功能

export interface IUsePostAPI20949Return {
  /** 增加常用功能: 接口请求状态 */
  isAPI20949Loading: boolean;
  /** 增加常用功能: 接口请求返回数据 */
  dataAPI20949: API20949Res;
  /**  增加常用功能: 接口数据请求方法 */
  fetchAPI20949Data:  (inputs: API20949Req, config?: YWRequestConfig) => Promise<API20949Res>;
  /** 增加常用功能: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI20949 = ():IUsePostAPI20949Return => {
  let isMount = true;
  const [isAPI20949Loading, setIsAPI20949Loading] = useState(false);
  const [dataAPI20949, setDataAPI20949] = useState<API20949Res>({} as API20949Res);
  const requestUrl = `${basePath}/ywwl-admin/desktop/home/common/function/add`;

  const fetchAPI20949Data = async (inputs: API20949Req, config?: YWRequestConfig): Promise<API20949Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API20949Req>) || {}) as API20949Req;
    
  
    if ( isMount ) {
      setIsAPI20949Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API20949Res>(`${basePath}/ywwl-admin/desktop/home/common/function/add`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI20949(res || {} as API20949Res);
        setIsAPI20949Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI20949Loading(false);
      }
      return false as unknown as API20949Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI20949Loading,
    dataAPI20949,
    fetchAPI20949Data,
    requestUrl,
  }
}

